import React, { useState, useEffect, useRef } from "react";
import Form from 'react-bootstrap/Form'
import Switch from "react-switch"
import '../admin/admin.css';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { ToastContainer, toast } from "react-toastify";
import YearCollapseSubject from "./YearCollapseSubject";
import { useAppStore, useBranchStore, useSubjectStore } from "../../stores";
import SelectBranch from "../admin/SelectBranch";
import { handleXhrError } from "../../utils";
const MySwal = withReactContent(Swal);
const toastOptions = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};
const AdminAddSubject = () => {
  const [openModal, setOpenModal] = useState(false);

  const currentBranch = useBranchStore(state => state.currentBranch);
  const loading = useAppStore(state => state.loading);
  const showLoading = useAppStore(state => state.showLoading);
  const subjects = useSubjectStore((state) => state.subjects);
  const addSubject = useSubjectStore((state) => state.addSubject);
  const [sem, setSem] = useState(1);
  // const branch = useSubjectStore(state => state.branch);
  const duration = currentBranch.duration;
  const subjectName = useRef();
  const yearRef = useRef();
  const defaultYear = currentBranch.years[0];
  const semesterRef = useRef();
  const postSubject = (e) => {
    e.preventDefault();
    e.target.disabled = true;
    // alert(JSON.stringify(currentBranch))
    window.$.ajax({
      type: "post",
      url: "/api/admin/subjects",
      xhrFields: {
        withCredentials: true,
      },
      data: {
        name: subjectName.current.value,
        year: parseInt(yearRef.current.value),
        sem: semesterRef.current.value,
        branch: currentBranch._id
      },
      dataType: "json",
      success: (response, textStatus, request) => {
        console.log(response);
        addSubject(response.subject);
        console.log("success")
        MySwal.fire("Subject successfully added");
        subjectName.current.value = "";
        yearRef.current.value = defaultYear;
        semesterRef.current.value = "1";
        e.target.disabled = false
      },
      statusCode: {

        404: function () {
          e.target.disabled = false;
          toast.error("page not found", toastOptions);
        },
        400: function (res) {
          e.target.disabled = false;
          if (!res.responseJSON) {
            toast.error("Something went wrong...", toastOptions);
            return;
          }

          toast.error(res.responseJSON.message, toastOptions);
          return;
        },
      },
      headers: {
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "",
      },
      error: function (res, textStatus, err) {
        handleXhrError(res, textStatus, err, () => {
          e.target.disabled = false;
        })
      },
    });
  }
  if (loading) {
    return showLoading();
  }
  return (
    <>
      {/* <ToastContainer /> */}
      <SelectBranch />
      <form className=" p-4 m-0" style={{ width: "99%" }}>
        <h1 className="mainHeading">{currentBranch.name} department</h1>
        <h5 className="mainHeading subheading">Add subjects in each year</h5>
        <h3 className="mainHeading mt-4">Add subjects</h3>
        <div className="row" id="addSection">
          <div className="form-group col-md-4">
            <label for="Degree" className="addSlabel">Subject</label>
            <input
              type="text"
              ref={subjectName}
              className="form-control addS"
              placeholder="Enter subject name"
            />
          </div>

          <div className="form-group col-md-4">
            <label for="years" className="addSlabel">Year-Batch</label>
            <Form.Select className="addS" ref={yearRef}>
              {
                currentBranch.years.map((d, index) => <option key={index} value={d}>{d}</option>)
              }
            </Form.Select>
          </div>
          <div className="form-group col-md-4">
            <label for="semesters" className="addSlabel">Semester</label>
            <Form.Select className="addS" ref={semesterRef}>
              <option value={1}>1</option>
              <option value={2}>2</option>
            </Form.Select>
          </div>
        </div>
        <div style={{ display: "flex", width: "100%", justifyContent: "center" }}>
          <button className="addSectionbtn col-md-4 mt-4 mb-3" onClick={postSubject}>Add Subject</button>
        </div>
        <h3 className="mainHeading m-0 ">Subjects you've added</h3>
        <div className="ms-auto me-auto col-3 d-flex justify-content-evenly">
          <span className="fs-4 fw-bolder text-info" style={{ whiteSpace: "nowrap", marginRight: "10px" }}>Show semister </span>
          <span className="mt-auto mb-auto">
            <Switch checkedIcon={<h4 style={{ color: "white", fontWeight: "700", paddingLeft: "0.6rem" }}>1</h4>} uncheckedIcon={<h4 style={{ color: "white", fontWeight: "700", paddingLeft: "0.4rem" }}>2</h4>} checked={sem == 1} onChange={() => setSem(3 - sem)} />
          </span>
        </div>
      </form>
      <YearCollapseSubject setOpenModal={setOpenModal} sem={sem} yearSelected={(yearRef.current ? yearRef.current.value : defaultYear)} />
    </>
  );
};

export default AdminAddSubject;
